export default [
    { id: "SN", label: "Simples Nacional" },
    { id: "Presumido", label: "Lucro Presumido" },
    { id: "Isento", label: "Isento" },
    { id: "Eand", label: "Aguardando enquadramento no simples" },
    { id: "Presumido_equi", label: "presumido com equiparação" },
    { id: "MEI", label: "Microempreendedor Individual (MEI)" },
  ];
  